module.exports = __webpack_public_path__ + "static/media/customStep5.0ac18572.png";